import { useCallback, useRef } from 'react';

import { pfpHintTipElementShownRaw } from '@hh.ru/analytics-js-events/build/xhh/employer/pfp/pfp_hint_tip_element_shown';
import { QuestionCircleOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { HoverTip } from 'bloko/blocks/drop';
import { TipLayer, TipPlacement } from 'bloko/blocks/drop/Tip';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import PfpVacancyTip from 'src/components/PfpVacancyTip';
import translation from 'src/components/translation';

import styles from './index.less';

const TrlKeys = {
    name: 'employer.vacancyResponses.pfpStub.name',
};

const renderTip = () => <PfpVacancyTip />;

interface PfpStubProps {
    resumeId: string;
    topicId?: string;
    vacancyId?: number;
}

const PfpStub: TranslatedComponent<PfpStubProps> = ({ trls, vacancyId, resumeId, topicId }) => {
    const activatorRef = useRef(null);
    const onHover = useCallback(() => {
        return pfpHintTipElementShownRaw({
            resumeId,
            topicId,
            vacancyId: vacancyId?.toString(),
        });
    }, [resumeId, topicId, vacancyId]);
    return (
        <div className={styles.wrapper}>
            {trls[TrlKeys.name]}
            <HoverTip
                flexible
                host={!process.env.SSR ? document.body : null}
                placement={TipPlacement.Bottom}
                layer={TipLayer.Overlay}
                render={renderTip}
                onHover={onHover}
                activatorRef={activatorRef}
            >
                <span ref={activatorRef}>
                    <QuestionCircleOutlinedSize16 initialColor="secondary" />
                </span>
            </HoverTip>
        </div>
    );
};

export default translation(PfpStub);
